import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';
import AuthRequired from './AuthRequired';
import MainLayout from '../Layout/MainLayout';

const ProtectedRoute = ({ children, requiredGroups = [] }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body1">Authenticating...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <AuthRequired />;
  }

  // Check if user has required groups
  if (requiredGroups.length > 0) {
    const hasRequiredGroup = requiredGroups.some(group => 
      user?.groups?.includes(group)
    );
    
    if (!hasRequiredGroup) {
      return (
        <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="center" 
          justifyContent="center" 
          minHeight="100vh"
          gap={2}
        >
          <Typography variant="h6" color="error">
            Access Denied
          </Typography>
          <Typography variant="body2">
            You don't have the required permissions to access this page.
          </Typography>
        </Box>
      );
    }
  }

  return (
    <MainLayout>
      {children}
    </MainLayout>
  );
};

export default ProtectedRoute;
